import React, { useContext } from 'react';
import type { WPublicWeddingView } from '@zola/svc-web-api-ts-client';
import { ThemeContext } from '../../../../context';
import { mapWeddingAccountToWebsiteDateProp } from '../../../../../../util/websiteDateUtil';
import DisplayType1 from './displayTypes/DisplayType1';
import DisplayType2 from './displayTypes/DisplayType2';

type LocationDateModuleProps = {
  wedding?: WPublicWeddingView;
  className?: string;
};

const LocationDateModule = ({
  wedding,
  className,
}: LocationDateModuleProps): JSX.Element | null => {
  const {
    homepage: {
      date_location: { display_type },
    },
  } = useContext(ThemeContext);

  if (!wedding) return null;

  const { city, state_province } = wedding;
  const websiteDate = mapWeddingAccountToWebsiteDateProp(wedding, undefined);

  const props = {
    city,
    state: state_province,
    websiteDate,
    className,
  };
  if (display_type === 'DISPLAY_TYPE_1') {
    return <DisplayType1 {...props} />;
  }
  return <DisplayType2 {...props} />;
};

export default LocationDateModule;
